/* eslint-disable */
import {PostHog} from 'posthog-js';

declare global {
  interface Window {
    posthog?: PostHog;
  }
}

let instance: ReturnType<typeof internalUsePostHog> | null = null;

export default function usePosthogHelper() {
    if (instance === null) {
      instance = internalUsePostHog();
    }

    return instance;
}

function internalUsePostHog() {

  const posthog = window.posthog;

  let eventQueue: QueuedEvent[] = [];
  let isProcessingQueue = false;
  let intervalId: number | null = null;

  function trackEvent(eventCategory: string, eventName: string, value?: Record<string, unknown>) {
    internalTrackEvent(`${eventCategory}-${eventName}`, value);
  }

  function internalTrackEvent(eventName: string, properties?: Record<string, unknown>) {
    if (!isPosthogAvailable()) {
      console.debug(
        'PostHog nie jest dostępny - dodaję event do kolejki:',
        eventName
      );
      addToQueue({ type: 'track', eventName, properties });
      return;
    }

    try {
      posthog!.capture(eventName, properties);
      console.debug('PostHog: Event wysłany', eventName, properties);
    } catch (error) {
      console.error('Błąd podczas wysyłania eventu do PostHog:', error);
    }
  }

  function setPersonProperties(properties: Record<string, unknown>) {
    const eventName = 'setPersonProperties'
    if (!isPosthogAvailable()) {
      console.debug(
        'PostHog nie jest dostępny - dodaję event do kolejki:',
      );
      addToQueue({ type: 'setPersonProperties', properties });
      return;
    }

    try {
      posthog!.setPersonProperties(properties);
      console.debug('PostHog: nadano tożsamość użytkownikowi', eventName, properties);
    } catch (error) {
      console.error('Błąd podczas wysyłania eventu do PostHog:', error);
    }
  }

  function identify(id: number, properties?: Record<string, unknown>) {
    const eventName = 'identify'
    if (!isPosthogAvailable()) {
      console.debug(
        'PostHog nie jest dostępny - dodaję event do kolejki:',
      );
      addToQueue({ type: 'identify', properties });
      return;
    }

    try {
      posthog!.identify(id.toString(10), properties);
      console.debug('PostHog: powiązano tożsamość użytkownika', eventName, properties);
    } catch (error) {
      console.error('Błąd podczas wysyłania eventu do PostHog:', error);
    }
  }


  //internal
  function isPosthogAvailable(): boolean {
    return !!posthog;
  }

  function startPosthogAvailabilityInterval() {
    if (intervalId) {
      return;
    }

    intervalId = window.setInterval(() => {
      if (isPosthogAvailable()) {
        processQueue();
      }
    }, 1000); //1s

    console.debug('PostHog: Rozpoczęto sprawdzanie dostępności');
  }

  function stopPostHogAvailabilityInterval() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
      console.debug('PostHog: Zatrzymano sprawdzanie dostępności');
    }
  }

  function addToQueue(event: QueuedEvent) {
    eventQueue.push(event);
    console.debug('Posthog: Event dodany do kolejki: ', event);

    startPosthogAvailabilityInterval();
  }

  function processQueue() {
    if (isProcessingQueue || !isPosthogAvailable() || eventQueue.length === 0)
      return;

    isProcessingQueue = true;

    const eventsToProcess = [...eventQueue];
    eventQueue = [];

    try {
      eventsToProcess.forEach((event, index) => {
        try {
          switch (event.type) {
            case 'setPersonProperties':
              posthog?.setPersonProperties(event.properties);
              break;
            case 'track':
              posthog?.capture(event.eventName, event.properties);
          }
        } catch (error) {
          console.error(
            'Błąd podczas przetwarzania eventu z kolejki:',
            error,
            event
          );
        }
      });

      console.debug('PostHog: Kolejka eventów została przetworzona');
    } finally {
      isProcessingQueue = false;
    }

    if (eventQueue.length === 0) {
      stopPostHogAvailabilityInterval();
    }
  }

  return { trackEvent, setPersonProperties, identify };
}

type QueuedEvent =
  { type: 'setPersonProperties', properties: Record<string, unknown> }
  | { type: 'track', eventName: string, properties?: Record<string, unknown> }
  | { type: 'identify', properties?: Record<string, unknown> }
